<template>
    <b-container fluid>
        <br>
        <h3>Profile</h3>
        <hr/>
        <div class="m-auto flexRow">
            <div class="col-12 col-xl-4">
                <b-card-header>Profile information</b-card-header>
                <b-card-body>
                    <v-list>
                        <v-list-item two-line>
                            <v-list-item-content>
                                <v-list-item-title class="profileInfoBox">First name</v-list-item-title>
                                <v-skeleton-loader
                                        :loading="this.loadingProfile"
                                        transition='scale-transition'
                                        ref="skeleton"
                                        type="text"
                                        class="mx-auto">
                                    <v-list-item-subtitle class="profileInfoBox">{{this.profileInfo.firstname}}
                                    </v-list-item-subtitle>
                                </v-skeleton-loader>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item two-line>
                            <v-list-item-content>
                                <v-list-item-title class="profileInfoBox">last name</v-list-item-title>
                                <v-skeleton-loader
                                        :loading="this.loadingProfile"
                                        transition='scale-transition'
                                        ref="skeleton"
                                        type="text"
                                        class="mx-auto">
                                    <v-list-item-subtitle class="profileInfoBox">{{this.profileInfo.lastname}}
                                    </v-list-item-subtitle>
                                </v-skeleton-loader>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item two-line>
                            <v-list-item-content>
                                <v-list-item-title class="profileInfoBox">Email address</v-list-item-title>
                                <v-skeleton-loader
                                        :loading="this.loadingProfile"
                                        transition='scale-transition'
                                        ref="skeleton"
                                        type="text"
                                        class="mx-auto">
                                    <v-list-item-subtitle class="profileInfoBox">{{this.profileInfo.email}}
                                    </v-list-item-subtitle>
                                </v-skeleton-loader>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item two-line>
                            <v-list-item-content>
                                <v-list-item-title class="profileInfoBox">Role(s)</v-list-item-title>
                                <v-skeleton-loader
                                        :loading="this.loadingProfile"
                                        transition='scale-transition'
                                        ref="skeleton"
                                        type="text"
                                        class="mx-auto">
                                    <v-list-item-subtitle class="profileInfoBox">
                                        {{this.formatList(this.profileInfo.role)}}
                                    </v-list-item-subtitle>
                                </v-skeleton-loader>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item two-line>
                            <v-list-item-content>
                                <v-list-item-title class="profileInfoBox">Amount of projects</v-list-item-title>
                                <v-skeleton-loader
                                        :loading="this.loadingProfile"
                                        transition='scale-transition'
                                        ref="skeleton"
                                        type="text"
                                        class="mx-auto">
                                    <v-list-item-subtitle class="profileInfoBox">
                                        {{this.profileInfo.amount_of_projects}}
                                    </v-list-item-subtitle>
                                </v-skeleton-loader>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </b-card-body>
                <b-card-footer>
                    <v-btn @click="changePassword" :style="primaryStyle" :loading="passwordLoading"
                           :disabled="passwordLoading">
                        change password
                    </v-btn>
                </b-card-footer>

            </div>
            <div class="col-12 col-xl-8">
                <b-card-header>Edit profile information</b-card-header>
                <form ref="edit_user_form">
                    <div class="flexRow">
                        <b-form-group
                                class="col-6"
                                label="First name"
                                label-for="first-name">
                            <b-form-input
                                    id="first-name"
                                    v-model="editable_account_info.firstname"/>
                            <b-form-invalid-feedback :state="validate_fn">
                                first name is required, it needs at least {{minNameLength}} characters.
                            </b-form-invalid-feedback>
                        </b-form-group>
                        <b-form-group
                                class="col-6"
                                label="Last name"
                                label-for="last-name">
                            <b-form-input
                                    id="last-name"
                                    v-model="editable_account_info.lastname"/>
                            <b-form-invalid-feedback :state="validate_ln">
                                last name is required, it needs at least {{minNameLength}} characters.
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                    <b-form-group
                            class="col-12"
                            label="Email address"
                            label-for="email">
                        <b-form-input
                                id="email"
                                v-model="editable_account_info.email"/>
                        <b-form-invalid-feedback :state="validate_email">
                            Email address is invalid
                        </b-form-invalid-feedback>
                    </b-form-group>
                </form>
                <b-card-footer>
                    <v-btn :loading="savingChanges"
                           :disabled="savingChanges"
                           :style="primaryStyle"
                           @click="edit_account">
                        save changes
                    </v-btn>
                </b-card-footer>
                <v-divider/>
                <b-card-header>Projects information</b-card-header>
                <b-card-body>
                    <v-skeleton-loader
                            :loading="this.loadingProjects"
                            transition='scale-transition'
                            ref="skeleton"
                            type="table"
                            class="mx-auto"
                            width="100%"
                            height="225">
                        <v-card>
                            <v-card-title>
                                Projects
                            </v-card-title>
                            <v-data-table
                                    hide-default-footer
                                    :headers="projectTableHeaders"
                                    :items="projects">
                            </v-data-table>
                        </v-card>
                    </v-skeleton-loader>
                </b-card-body>
            </div>
        </div>
        <edit-password @loadingChanged="passwordLoading = !passwordLoading"/>
    </b-container>
</template>

<script>
    import AccountRepository from '../../../repositories/account.repository';
    import EditPassword from "./EditPassword";

    export default {
        components: {
            EditPassword,
        },
        props: {
            editable_account_info: {
                type: Object,
                default: AccountRepository.accountInfo,
            },
        },
        data() {
            return {
                loadingProfile: true,
                loadingProjects: true,
                savingChanges: false,
                passwordLoading: false,
                minNameLength: process.env.VUE_APP_VALIDATION_USER_MIN_NAME_LENGTH,
                profileInfo: AccountRepository.blankUser(),
                projectTableHeaders: [
                    {text: 'Project Name', value: 'project_name', filterable: true},
                    {text: 'Webhook amount', value: 'amount_of_webhooks', filterable: true},
                    {text: 'CronSubscriber amount', value: 'amount_of_cronSubscriber', filterable: true},
                    {text: 'Task amount', value: 'amount_of_tasks', filterable: true},
                ],
                projects: [],
            }
        },
        created() {
            this.loadingProfile = true;
            AccountRepository.getUserInfo().then(res => {
                this.profileInfo = res.data;
                this.editable_account_info.firstname = this.profileInfo.firstname;
                this.editable_account_info.lastname = this.profileInfo.lastname;
                this.editable_account_info.email = this.profileInfo.email;
                this.loadingProfile = false;
            }).catch(error => {
                this.loadingProfile = false;
                this.$bvToast.toast('Looks like something went wrong while getting your profile info', {
                    title: `Profile error.`,
                    variant: 'danger',
                    solid: true
                });
            });
            AccountRepository.getProjectsInfo().then(res => {
                this.projects = res.data;
                this.loadingProjects = false;
            })
        },
        methods: {
            checkFields() {
                if (AccountRepository.validate.firstName(this.editable_account_info.firstname) === false) return false;
                if (AccountRepository.validate.lastName(this.editable_account_info.lastname) === false) return false;
                if (AccountRepository.validate.email(this.editable_account_info.email) === false) return false;
                return true;
            },
            changePassword() {
                this.$bvModal.show('edit_password_modal');
            },
            formatList(list) {
                let string = "";
                for (let i = 0; i < list.length; i++) {
                    string = string + (i === 0 ? "" : ", ") + list[i];
                }
                return string;
            },
            edit_account(modal) {
                if (this.checkFields()) {
                    this.savingChanges = true;
                    AccountRepository.updateAccountInfo(this.editable_account_info).then(res => {
                        // Notify the user.
                        this.$bvToast.toast(`User ${res.data.firstname + ' ' + res.data.lastname} successfully edited.`, {
                            title: `User edited.`,
                            variant: 'success',
                            solid: true
                        });
                        this.profileInfo = res.data;
                        this.editable_account_info.firstname = this.profileInfo.firstname;
                        this.editable_account_info.lastname = this.profileInfo.lastname;
                        this.editable_account_info.email = this.profileInfo.email;
                        this.savingChanges = false;
                    }).catch(error => {
                        if (error.response.status === 422) {
                            console.error("Errorcode: " + error.response.status + " Type: " + error.response.statusText + " \n details:" + error.response.data['hydra:description']);
                            this.$bvToast.toast('Looks like something went wrong while validating the your profile information. Check the value\'s of all the fields', {
                                title: `profile edit error.`,
                                variant: 'danger',
                                solid: true
                            });
                        } else {
                            console.error("Errorcode: " + error.response.status + " Type: " + error.response.statusText);
                            this.$bvToast.toast('Looks like something went wrong on the server while editing your profile.', {
                                title: `Profile edit error.`,
                                variant: 'danger',
                                solid: true
                            });
                        }
                        this.savingChanges = false;
                    });
                } else {
                    modal.preventDefault();
                }
            }
        },
        computed: {
            validate_fn() {
                return AccountRepository.validate.firstName(this.editable_account_info.firstname);
            },
            validate_ln() {
                return AccountRepository.validate.lastName(this.editable_account_info.lastname);
            },
            validate_email() {
                return AccountRepository.validate.email(this.editable_account_info.email);
            },
        }
    }
</script>
<style>

    .profileInfoBox {
        padding: 1px 0px;
    }

</style>

